import { render, staticRenderFns } from "./_updateTaskSubjectModal.vue?vue&type=template&id=54b493da"
import script from "./_updateTaskSubjectModal.vue?vue&type=script&lang=js"
export * from "./_updateTaskSubjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports